import * as actions from '../actions/actionTypes';

const initialState = {
  schedules: [],
};

const fetchSchedulesSuccess = (state, action) => ({ ...state, schedules: action.schedules });

const deleteScheduleSuccess = (state, action) => {
  const newSchedules = state.schedules.filter(schedule => schedule.workingDay.id !== action.id);
  return {
    ...state,
    schedules: newSchedules,
  };
};

const updateScheduleNameSuccess = (state, action) => {
  const updatedSchedules = state.schedules.map((schedule) => {
    if (schedule.workingDay.id === action.id) {
      const updatedSchedule = schedule;
      updatedSchedule.workingDay.description = action.name;
      return updatedSchedule;
    }
    return schedule;
  });
  return {
    ...state,
    schedules: updatedSchedules,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_SCHEDULES_SUCCESS: return fetchSchedulesSuccess(state, action);
    case actions.DELETE_SCHEDULE_SUCCESS: return deleteScheduleSuccess(state, action);
    case actions.UPDATE_SCHEDULE_NAME_SUCCESS: return updateScheduleNameSuccess(state, action);

    default: return state;
  }
};

export default reducer;
